import {appendVisitorIdToUrl} from './append-visitor-id-to-url';

export function loadScript(src) {
    const domainWhiteList = [
        'https://widget.gleamjs.io',
        'https://csvcus.homeaway.com',
    ];

    if (!domainWhiteList.filter((domain) => src.includes(domain)).length) {
        return;
    }

    if (src.includes('gleam')) {
        appendVisitorIdToUrl();
    }

    const script = document.createElement('script');
    script.src = src;
    document.head.appendChild(script);
}
